import { createAction, props } from '@ngrx/store';
import MapView from '@arcgis/core/views/MapView';

export enum ActionTypes {
    //Action of middleware core
    InitMap = '[MAP_SURVEY_ACT_MIDDLEWARE] INIT_MAP',
    DestroyMap = '[MAP_SURVEY_ACT_MIDDLEWARE] DESTROY_MAP',

    BindMapCommand = '[MAP_SURVEY_ACT_MIDDLEWARE] BIND_MAP_COMMAND',
    BindEvtClickMap = '[MAP_SURVEY_ACT_MIDDLEWARE] ON_CLICK_MAP',

    //Action of middleware (Measurement)
    InitDrawerMeasurement = '[MAP_SURVEY_ACT_MIDDLEWARE] INIT_DRAWER_MEASUREMENT',
    BindEvtCompleteDrawerMeasurement = '[MAP_SURVEY_ACT_MIDDLEWARE] ON_CLICK_COMPLETE_DRAW_MEASUREMENT',
    DestroyMeasurement = '[MAP_SURVEY_ACT_MIDDLEWARE] DESTROY_MEASUREMENT',

    DrawGraphic = '[MAP_SURVEY_ACT_MIDDLEWARE] DRAWER_Graphic',
    DrawHighlight = '[MAP_SURVEY_ACT_MIDDLEWARE] DRAWER_HIGHLIGHT',
    DrawPointHighlight = '[MAP_SURVEY_ACT_MIDDLEWARE] DRAWER_POINTHIGHLIGHT',
}

export const initMap = createAction(
    ActionTypes.InitMap,
    props<{ mapView: MapView }>()
);

export const bindMapCommand = createAction(
    ActionTypes.BindMapCommand,
    props<{ mapFunction: Function; params?: any }>()
);

export const destroyMap = createAction(ActionTypes.DestroyMap);

export const onClickMap = createAction(
    ActionTypes.BindEvtClickMap,
    props<{ callbackFunction: any }>()
);

export const initDrawerMeasurement = createAction(
    ActionTypes.InitDrawerMeasurement
);

export const bindDrawCompleteMeasurement = createAction(
    ActionTypes.BindEvtCompleteDrawerMeasurement,
    props<{ callbackFunction: (geometry: __esri.Geometry) => void }>()
);

export const destroyMeasurement = createAction(ActionTypes.DestroyMeasurement);
export const drawGraphic = createAction(
    ActionTypes.DrawGraphic,
    props<{ params?: __esri.PointProperties }>()
);

export const drawHighlightGraphic = createAction(
    ActionTypes.DrawHighlight,
    props<{ params?: __esri.PointProperties }>()
);
export const drawPointHightlight = createAction(
    ActionTypes.DrawPointHighlight,
    props<{ params?: __esri.PointProperties }>()
);
